import { render, staticRenderFns } from "./ChemicalCompositionForm.vue?vue&type=template&id=2e23cafd&scoped=true&"
import script from "./ChemicalCompositionForm.vue?vue&type=script&lang=js&"
export * from "./ChemicalCompositionForm.vue?vue&type=script&lang=js&"
import style0 from "./ChemicalCompositionForm.vue?vue&type=style&index=0&id=2e23cafd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e23cafd",
  null
  
)

export default component.exports